// ##############################
// // // ValidationForms view styles
// #############################

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx';
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx';
import customSelectStyle from 'assets/jss/material-dashboard-pro-react/customSelectStyle.jsx';
import {buttonGroupStyle} from 'assets/jss/AdsFilter';

const validationFormsStyle = {
	...customCheckboxRadioSwitch,
	...customSelectStyle,
	...buttonGroupStyle,
	pageContainer: {
		padding: "0 5%"
	},
	cardContainer: {
		width: '540px'
	},
	cardTitle: {
		...cardTitle,
		color: '#FFFFFF',
		textAlign: 'center'
	},
	cardIconTitle: {
		...cardTitle,
		marginTop: '15px',
		marginBottom: '0px'
	},
	formCategory: {
		marginBottom: '0',
		color: '#999999',
		fontSize: '14px',
		padding: '10px 0 10px'
	},
	center: {
		textAlign: 'center'
	},
	justifyContentCenter: {
		justifyContent: 'center'
	},
	registerButton: {
		float: 'right'
	},
	userSelect: {
		width: '100%',
		marginTop: -24,
	},
	userAvatar: {
		'& .fileinput .thumbnail.img-circle': {
			height: '100px',
			'& img': {
				height: '100%',
				objectFit: 'cover'
			}
		},
		'& .button-actions': {
			'@media (min-width: 768px)': {
				display: 'flex',
				alignItems: 'center'
			}
		}
	},
	title: {
		margin: 0
	},
	eraseUserBtn: {
		padding: 0,
		margin: '16px 0',
		'@media (min-width: 391px)': {
			margin: 0,
		}
	},
	saveChangesbtn: {
		float: 'right',
		width: '100%',
		'@media (min-width: 768px)': {
			width: 'auto',
		}
	},
	editUserFormContainer: {
		margin: '32px 0',
		'& .react-tagsinput .react-tagsinput-tag.info': {
			backgroundColor: '#2DAAF2',
			fontSize: '15px',
			fontWeight: 400,
			padding: '0.4em 0.7em',
			borderRadius: '22px',
			'&:hover': {
				paddingRight: '2em',
				'& a': {
					paddingRight: '9px',
					top: '6px',
					color: '#FFFFFF'
				}
			}
		},
		'& .react-tagsinput-input': {
			width: '112px'
		}
	},
	reviewDD: {
		width: '100%',
		'&:before, &:after': {
			display: 'none'
		},
		'& svg': {
			right: '15px',
		},
	},
	select: {
		border: '1px solid #2DAAF2',
		borderRadius: '8px',
		padding: '8px 16px',
		fontSize: '14px',
		fontWeight: 400,
		'&:focus': {
			borderRadius: '8px'
		},
	},
    section: {
      marginTop: '32px'
    },
    errorSpecialFields: {
      fontSize: '0.75rem',
      color: '#f44336',
      margin: 0,
    },
	tagsInput: {
		marginTop: '32px',
		'& h6': {
			marginBottom: 0
		}
	}
};

export default validationFormsStyle;
